module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAyCAMAAABmvHtTAAAAM1BMVEUAAAD////////////////////////////////////////////////////////qMTH1mJjQxDJoAAAADnRSTlMAvRDz2cWQXFE7A9aioXs9BooAAACLSURBVCjPjdPhCsMgDARgL2qrrr3t/Z92MEbSclDNH+EDwcRLygXnbula/BWaEFm7ELkNIcKE+DIhYghxU2JXqkpsSlCiKe1KhxKUilK+0Od/ppC3k4uTS5BLkEtQiNDkYtjTI8ImDWnbOpz5CKF0Ln2arQSgrYSpLwQTYx5y2HRhan9avlxw3Ff0C8vxKUvEyHC5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/left.png
// module id = if7D
// module chunks = 1